import { I18n } from 'aws-amplify';
import React from 'react';
import PropTypes from 'prop-types';
import { Checkbox } from 'primereact/checkbox';

ControleCoffret.propTypes = {
    controle: PropTypes.object.isRequired
};

function ControleCoffret(props) {
    const date = new Date(props.controle.controlDate[0] + "-" + props.controle.controlDate[1] + "-" + props.controle.controlDate[2]);

    return (
        <div>
            <h2 className='text-xl font-semibold mb-4'>
                <i className="fa-light fa-calendar mr-2"></i>
                {I18n.get("dernierControle") + " " + date?.toLocaleDateString()}
            </h2>
            <div className='cdm-form-label'>{I18n.get("controlOrg")}</div>
            <div className='cdm-form-data'>{I18n.get("controlOrg"+props.controle.idControlOrg)}</div>

            <div className='flex '>
                <div className='flex flex-column w-6'>
                    <div className='cdm-form-label'>{I18n.get("o2zb")}</div>
                    <div className='cdm-form-data flex align-items-center'>
                        <div className='w-6'>{props.controle.o2Zb?.toFixed(2)}</div>
                        <div className='flex align-items-center w-6'>
                            <Checkbox checked={props.controle.o2Zbc === 1} disabled />
                        </div>
                    </div>
                </div>
                <div className='flex flex-column w-6'>
                    <div className='cdm-form-label'>{I18n.get("o2ze")}</div>
                    <div className='cdm-form-data flex align-items-center'>
                        <div className='w-6'>{props.controle.o2Ze?.toFixed(2)}</div>
                        <div className='flex align-items-center w-6'>
                            <Checkbox checked={props.controle.o2Zec === 1} disabled />
                        </div>
                    </div>
                </div>
            </div>
            
            <div className='flex'>
                <div className='flex flex-column w-6'>
                    <div className='cdm-form-label'>{I18n.get("cozb")}</div>
                    <div className='cdm-form-data flex align-items-center'>
                        <div className='w-6'>{props.controle.coZb?.toFixed(2)}</div>
                        <Checkbox checked={props.controle.coZbc === 1} disabled />
                    </div>
                </div>
                <div className='flex flex-column w-6'>
                    <div className='cdm-form-label'>{I18n.get("coze")}</div>
                    <div className='cdm-form-data flex align-items-center'>
                        <div className='w-6'>{props.controle.coZe?.toFixed(2)}</div>
                        <Checkbox checked={props.controle.coZec === 1} disabled />
                    </div>
                </div>
            </div>

            <div className='flex'>
                <div className='flex flex-column w-6'>
                    <div className='cdm-form-label'>{I18n.get("tempzb")}</div>
                    <div className='cdm-form-data flex align-items-center'>
                        <div className='w-6'>{props.controle.tempZb?.toFixed(2)}</div>
                        <Checkbox checked={props.controle.tempZbc === 1} disabled />
                    </div>
                </div>
                <div className='flex flex-column w-6'>
                    <div className='cdm-form-label'>{I18n.get("tempze")}</div>
                    <div className='cdm-form-data flex align-items-center'>
                        <div className='w-6'>{props.controle.tempZe?.toFixed(2)}</div>
                        <Checkbox checked={props.controle.tempZec === 1} disabled />
                    </div>
                </div>
            </div>

            <div className='flex'>
                <div className='flex flex-column w-6'>
                    <div className='cdm-form-label'>{I18n.get("pompeSui")}</div>
                    <div className='cdm-form-data flex align-items-center'>
                        <div className='w-6 '>{props.controle.pompeSui?.toFixed(2)}</div>
                        <Checkbox checked={props.controle.pompeSuiEc === 1} disabled />
                    </div>
                </div>
                <div className='flex flex-column w-6'>
                    <div className='cdm-form-label'>{I18n.get("deprimometre")}</div>
                    <div className='cdm-form-data flex align-items-center'>
                        <div className='w-6'>{props.controle.deprimometre}</div>
                        <Checkbox checked={props.controle.deprimometreC === 1} disabled />
                    </div>
                </div>
            </div>

            <div className='flex'>
                <div className='flex flex-column w-6'>
                    <div className='flex align-items-center'>
                        <div className='cdm-form-label w-6'>{I18n.get("echelleGris")}</div>
                        <Checkbox checked={props.controle.echelleGrisC === 1} disabled />
                    </div>
                </div>
                <div className='flex flex-column w-6'>
                    <div className='flex align-items-center'>
                        <div className='cdm-form-label w-6'>{I18n.get("sondeMtrous")}</div>
                        <Checkbox checked={props.controle.sondeMtrousC === 1} disabled />
                    </div>
                </div>
            </div>

            <div className='flex pt-4'>
                <div className='flex flex-column w-6'>
                    <div className='flex align-items-center'>
                        <div className='cdm-form-label w-6'>{I18n.get("sondeEspaceA")}</div>
                        <Checkbox checked={props.controle.sondeEspaceAC === 1} disabled />
                    </div>
                </div>
                <div className='flex flex-column w-6'>
                    <div className='flex align-items-center'>
                        <div className='cdm-form-label w-6'>{I18n.get("miroir")}</div>
                        <Checkbox checked={props.controle.miroirC === 1} disabled />
                    </div>
                </div>
            </div>

            <div className='flex pt-4'>
                <div className='flex flex-column w-6'>
                    <div className='flex align-items-center'>
                        <div className='cdm-form-label w-6'>{I18n.get("indRefoulement")}</div>
                        <Checkbox checked={props.controle.indRefoulementC === 1} disabled />
                    </div>
                </div>
                <div className='flex flex-column w-6'>
                    <div className='flex align-items-center'>
                        <div className='cdm-form-label w-6'>{I18n.get("supportSonde")}</div>
                        <Checkbox checked={props.controle.supportSondeC === 1} disabled />
                    </div>
                </div>
            </div>

            <div className='flex flex-column w-6 pt-4'>
                <div className='flex align-items-center'>
                    <div className='cdm-form-label w-6'>{I18n.get("endoscope")} </div>
                    <Checkbox checked={props.controle.endoscopeC === 1} disabled/>
                </div>
            </div>

            <div className='flex flex-column w-6 pt-4'>
                <div className='flex align-items-center'>
                    <div className='cdm-form-label w-6'>{I18n.get("resultat")}</div>
                    {props.controle.resultat === 1 ?
                        <i className="fas fa-check-circle text-green-500" style={{ fontSize: '2em' }}></i>
                        : <i className="fas fa-times-circle text-red-500" style={{ fontSize: '2em' }}></i>}
                </div>
            </div>

            <div className='cdm-form-label pt-4'>{I18n.get("remarque")}</div>
            <div className='cdm-form-data'>{props.controle.remarque}</div>

        </div>
    )
}

export default ControleCoffret;